import { render, staticRenderFns } from "./PopupDayRecipeEmail.vue?vue&type=template&id=47b30823"
import script from "./PopupDayRecipeEmail.vue?vue&type=script&lang=js"
export * from "./PopupDayRecipeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports